import {
  CreateAccountabilityTemplateRequest,
  GenerateAccountabilityTemplateSessionRequest,
  UpdateAccountabilityTemplateRequest,
  ViewAccountabilityTemplateRequest
} from './accountability-template.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/accountability-template`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateAccountabilityTemplateRequest = (
  data: CreateAccountabilityTemplateRequest
): [string, HttpPostOptions<CreateAccountabilityTemplateRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewAccountabilityTemplateRequest = (
  data: ViewAccountabilityTemplateRequest
): [string, HttpGetOptions] => [getSpecificEndpoint(data.programmeExternalReference), getHttpGetOptions()];

export const getUpdateAccountabilityTemplateRequest = (
  data: UpdateAccountabilityTemplateRequest
): [string, HttpPutOptions<UpdateAccountabilityTemplateRequest>] => [getEndpoint(), getHttpPutOptions(data)];

export const getGenerateAccountabilityTemplateSessionRequest = (
  data: GenerateAccountabilityTemplateSessionRequest
): [string, HttpPostOptions<GenerateAccountabilityTemplateSessionRequest>] => [
  `${getEndpoint()}/attendance`,
  getHttpPostOptions(data)
];
